export const statusOptions = [
    { label: 'Refunded', color: 'rgb(239, 68, 68)', value: 'REFUNDED' },
    { label: 'Fully Paid', color: 'rgb(34, 197, 94)', value: 'FULLY_PAID' },
    { label: 'Partially Paid', color: 'rgb(131, 83, 226)', value: 'PARTIALLY_PAID' },
    { label: 'Payment Pending', color: 'rgb(197, 156, 12)', value: 'PENDING' },
];

export const accTypeOptions = [
    { label: 'Trust Account', color: 'rgb(107, 174, 214)', value: 'TRUST' },
    { label: 'Business Account', color: 'rgb(34, 197, 94)', value: 'BUSINESS' },
];
